import React from 'react'
import { Link } from 'react-router-dom'
import '../../Assets/CSS/Footer.css'
import { OtherImages } from '../../Assets/Images/CelcomOtherImages'


export default function Footer({ loginPage }) {
  return (
    <div className={`footer-start-section ${loginPage ? "footer-start-section-login" : ""}`}>
      {/* <div className="footer-col-section">
        <a href='https://www.celcom.com.my/legal/privacy-matters' className="footer-legal-links">
          Privacy Policy
        </a>
 
        <a href='https://www.celcom.com.my/legal/terms-and-conditions' className="footer-legal-links">
          Terms & Conditions
        </a>
      </div> */}
      <div className="footer-col-section ">
          <img src={OtherImages.footerCelcomDigi} alt="" />
      </div>
      <div className="footer-col-section">
       CelcomDigi Fibre Management Portal 2.0
      </div>
    </div>
  )
}